var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAffiliations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    width: 26,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12.5,
    fill: "#335280",
    r: 6.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#60B6B1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 6.25A6.25 6.25 0 016.75 0h12.5A6.25 6.25 0 0113 6.25zM13 18.75A6.25 6.25 0 006.75 25h12.5A6.25 6.25 0 0013 18.75zM19.25 12.277a6.25 6.25 0 006.25 6.25v-12.5a6.25 6.25 0 00-6.25 6.25zM6.75 12.277a6.25 6.25 0 01-6.25 6.25v-12.5a6.25 6.25 0 016.25 6.25z"
  }))));
}
export default SvgAffiliations;